/**
 * Helper na generovanie URL pre API podľa hostname/prostredia.
 * @module urlHelper
 */
//const serverUrl = process.env.NODE_ENV === "production" ? `${process.env.REACT_APP_PROD_URL}` : `${process.env.REACT_APP_PROD_URL}`;
const serverUrl = getUrl();
export function getUrl() {
  // TODO Matej
  // pre produkcnu verziu nesmie byt a skor to riesit cez podmienku
  //if (process.env.NODE_ENV === "production")
  //return process.env.REACT_APP_PROD_URL

  /*
  REACT_API_LOCALHOST_URL=https://localhost:44350/
  REACT_API_TEST_INVER_URL=https://erpapi.iist.inver.sk/
  REACT_API_CROCO_URL=http://marvinapi.ad.croco.cz/
  REACT_API_CROCODILLE_URL=https://marvinapi.crocodille.com/
  REACT_API_TESTCROCO_URL=http://marvinapitest.ad.croco.cz/
  REACT_API_TESTCROCODILLE_URL=https://marvinapitest.crocodille.com/
  */

  // ostre verzie
  if (window.location.hostname === "inver.sk") {
    //return process.env.REACT_API_CROCODILLE_URL;
    return "https://webapi.inver.sk/";
  }

  if (window.location.hostname === "inver.iis1.inver.sk") {
    //return process.env.REACT_API_CROCODILLE_URL;
    return "https://webapi.inver.sk/";
  }
 
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname.slice(0, 4) === "172."
  ) {
    //return process.env.REACT_API_LOCALHOST_URL;
    return "https://localhost:7104/";
  }
  if (
    window.location.hostname.slice(0, 3) === "10." ||
    window.location.hostname.slice(0, 4) === "192."
  ) {
    //return process.env.REACT_API_LOCALHOST_URL;
    return "https://localhost:7104/";
  }
  return window.location.protocol + "//" + window.location.hostname + "/";
}

//api/system/Contact
export const contactUrl = serverUrl + `api/system/Contact`;

//api/system/captcha
export const captchaUrl = serverUrl + `api/system/captcha/verify`;